function displayAttribute(value, defaultValue = '-') {
  return value || defaultValue
}

export default displayAttribute
